module.exports = __webpack_public_path__ + "3b6cba9a41c486d055265893f0c31635.png";